export const ENDPOINT_OPTIONS = [
  'users/update',
  'events/track',
  'commerce/updateCart',
  'commerce/trackPurchase',
] as const;

export const ENDPOINTS_DROPDOWN_OPTIONS = ENDPOINT_OPTIONS.map((option) => ({
  label: option,
  value: option,
}));

export const ENDPOINT_BLUEPRINTS = {
  'users/update': {
    email: 'andrew+petco@iterable.com',
    dataFields: {
      phoneNumber: '5555555555',
      fullName: 'Andrew Boni',
      addressLine1: ' 360 3rd Street',
      addressCity: 'San Francisco',
      addressZip: '94117',
      petProfile: [
        {
          petName: 'Holly',
          type: 'Dog',
          breed: 'Beagle',
          birthday: '2012-09-20',
          lastVisit: '2018-01-20',
        },
        {
          petName: 'Maya',
          type: 'Cat',
          breed: 'Bengal',
          lastVisit: '2018-03-11',
        },
      ],
      myStore: {
        addressLine1: '416 Eisenhower Dr',
        city: 'Hanover',
        state: 'PA',
        zip: '17331',
        distanceFromPrimary: 4.3,
        services: ['Dog Training', 'Full-service Grooming', 'Vaccinations'],
      },
    },
  },
  'events/track': {
    email: 'andrew+petco@iterable.com',
    eventName: 'adoption',
    dataFields: {
      petName: 'Maya',
      type: 'Cat',
      breed: 'Bengal',
      birthday: '2015-01-11',
    },
  },
  'commerce/updateCart': {
    user: {
      email: 'string',
      dataFields: {},
      userId: 'string',
      preferUserId: true,
      mergeNestedObjects: true,
    },
    items: [
      {
        id: 'string',
        sku: 'string',
        name: 'string',
        description: 'string',
        categories: ['string'],
        price: 0,
        quantity: 0,
        imageUrl: 'string',
        url: 'string',
        dataFields: {},
      },
    ],
  },
  'commerce/trackPurchase': {
    user: {
      email: 'foo@iterable.com',
    },
    items: [
      {
        id: '1',
        sku: '1',
        name: 'item',
        categories: ['cat', 'nutrition'],
        price: 45.99,
        quantity: 1,
        imageUrl: '',
        url: 'petco.com',
      },
      {
        id: '2',
        sku: '2',
        name: 'Bond & Co Pink Glitz and Glamour Bow Cat Collar',
        categories: ['cat', 'collars, leashes, & harnesses'],
        price: 9.99,
        quantity: 1,
        imageUrl: '',
        url: 'petco.com',
      },
    ],
    total: 65.97,
    dataFields: {
      shippingAddress1: '360 3rd Street',
      shippingAddress2: 'Suite 675',
      city: 'San Francisco',
      state: 'CA',
      zip: 94107,
    },
  },
};
